<template>
  <div class="vocation-intro-content" id="plataforma-de-marca-vocacao-intro" data-search-anchor>
    <div class="description-vocation-intro-content">
      <h1 class="vocation-intro-description">{{ introDescription }}</h1>
    </div>

    <div class="vocation-intro-card-item" :style="{ backgroundImage: `url(${introImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VocationPageMixin from '@/mixins/vocation-page-mixin'
import { VocationPageStore } from '@/store/brand-plataform-page/vocation-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
 
@Component({})
export default class VocationIntroSection extends Mixins(VocationPageMixin) {
  vocationPageStore: PageStoreContract = getModule( VocationPageStore, this.$store)
  get introDescription(): string {
    return this.getElementText(1, 0)
  }

  get introImageSrc(): string {
    return this.getElementMedia(1, 1)
  }

  async getVocationPage(): Promise<void> {
    await this.vocationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vocationPageStore.isLoading) {
      await this.getVocationPage()
    }
  }
}
</script>

<style lang="scss">
.vocation-intro-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;  
}

.description-vocation-intro-content {
  font-size: 70px;
    font-weight: 400;
    line-height: 60px;
    letter-spacing: -.01em;
    text-align: left;
    margin-top: 1rem;
    padding-right: 46px;
}

.vocation-intro-description {
  font-size: 45px;
  font-weight: 400;
  line-height: 50px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0; 
}

.vocation-intro-card-item {
  position: relative;
  border-radius: 12px;  
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
